// extracted by mini-css-extract-plugin
export default {"container":"style_container__RYTcL","titleSection":"style_titleSection__H-IAA"};